import React, { useState } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Icon from "components/ui/Icon";
import DisappearingTile from "components/ui/DisappearingTile";
import { getAdminDashboard } from "store/admin/api/apiSlice";
import { colors } from "utils/theme";
import { formatCurrency } from "utils/string";
import * as Styled from "../styled";
import { CHART_PERIOD_OPTIONS, CHART_TYPE_OPTIONS, CURVE } from "./constants";
import { getChartsData } from "./utils";
import Chart from "./Chart";

const Dashboard = () => {
  const [chartType, setChartType] = useState(CHART_TYPE_OPTIONS[0].name);
  const [chartPeriod, setChartPeriod] = useState(CHART_PERIOD_OPTIONS[0].name);
  const { data } = getAdminDashboard();

  if (!data) return null;

  const chartsData = getChartsData(data);

  return (
    <DisappearingTile size="xl">
      <Styled.Wrapper>
        <Styled.Section size={12}>
          <Styled.Options>
            <ToggleButtonGroup
              onChange={(_e, value) => {
                if (value) {
                  setChartType(value);
                }
              }}
              value={chartType}
              exclusive
            >
              {CHART_TYPE_OPTIONS.map((option) => (
                <ToggleButton value={option.name} key={option.name}>
                  <Icon name={option.icon} size="md" />
                </ToggleButton>
              ))}
            </ToggleButtonGroup>

            <ToggleButtonGroup
              onChange={(_e, value) => {
                if (value) {
                  setChartPeriod(value);
                }
              }}
              value={chartPeriod}
              exclusive
            >
              {CHART_PERIOD_OPTIONS.map((option) => (
                <ToggleButton value={option.name} key={option.name}>
                  {option.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Styled.Options>
        </Styled.Section>

        <Styled.Section size={12}>
          <Chart
            chartType={chartType}
            chartPeriod={chartPeriod}
            seriesProps={{
              label: "Card Spend",
              color: colors.azure,
              valueFormatter: (v) =>
                formatCurrency(v / 100, true).split(".")[0],
              curve: CURVE,
            }}
            dataset={chartsData.cardSpend[chartPeriod]}
            yAxisProps={{
              valueFormatter: (v) => `${(v / (100 * 1_000)).toLocaleString()}K`,
            }}
          />
        </Styled.Section>

        <Styled.Section size={6}>
          <Chart
            chartType={chartType}
            chartPeriod={chartPeriod}
            seriesProps={{
              used: {
                label: "Cards Used",
                color: colors.heliotrope,
                curve: CURVE,
              },
              issued: {
                label: "Cards Issued",
                color: colors.violet,
                curve: CURVE,
              },
            }}
            valueKeys={["used", "issued"]}
            dataset={chartsData.cardCount[chartPeriod]}
            // Linear projection of cards used in current month doesn't make sense
            hideProjectionForKeys={["used"]}
          />
        </Styled.Section>

        <Styled.Section size={6}>
          <Chart
            chartType={chartType}
            chartPeriod={chartPeriod}
            seriesProps={{
              label: "Transactions",
              color: colors.clementine,
              curve: CURVE,
            }}
            dataset={chartsData.transactionCount[chartPeriod]}
          />
        </Styled.Section>
      </Styled.Wrapper>
    </DisappearingTile>
  );
};

export default Dashboard;
